/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  /* eslint-disable */

  window.PXUTheme.jsAjaxCart = {
    init: function ($section) {
      // Add settings from schema to current object
      window.PXUTheme.jsAjaxCart = $.extend(
        this,
        window.PXUTheme.getSectionData($section)
      );

      if (isScreenSizeLarge() || this.cart_action == "drawer") {
        this.initializeAjaxCart();
      } else {
        this.initializeAjaxCartOnMobile();
      }

      if (this.cart_action == "drawer") {
        this.ajaxCartDrawer = $("[data-ajax-cart-drawer]");

        $(document).on("click", "[data-ajax-cart-trigger]", function (e) {
          e.preventDefault();
          window.PXUTheme.jsAjaxCart.showDrawer();
          return false;
        });
      } else if (this.cart_action == "mini_cart") {
        this.showMiniCartOnHover();
      }

      // Use event delegation for better performance
      $(document).on("click", ".ajax-submit", function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest("form");
        window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);
        return false;
      });

      $(document).on("click", "[data-ajax-cart-delete]", function (e) {
        e.preventDefault();
        const lineID = $(this).parents("[data-line-item]").data("line-item");
        window.PXUTheme.jsAjaxCart.removeFromCart(lineID);
        return false;
      });

      $(document).on("click", "[data-ajax-cart-close]", function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.hideDrawer();
        window.PXUTheme.jsAjaxCart.hideMiniCart();
        return false;
      });
    },

    showMiniCartOnHover: function () {
      const $el = $("[data-ajax-cart-trigger]");

      $el.hover(
        function () {
          if (
            window.PXUTheme.theme_settings.header_layout == "centered" &&
            $(".header-sticky-wrapper").hasClass("is-sticky")
          ) {
            $(".header-sticky-wrapper [data-ajax-cart-trigger]").addClass(
              "show-mini-cart"
            );
          } else {
            $el.addClass("show-mini-cart");
          }
        },
        function () {
          $el.removeClass("show-mini-cart");
        }
      );
    },

    hideMiniCart: function () {
      if (this.cart_action != "mini_cart") return false;
      const $el = $("[data-ajax-cart-close]").parents(
        "[data-ajax-cart-trigger]"
      );
      $el.removeClass("show-mini-cart");
    },

    toggleMiniCart: function () {
      const $el = $(".mobile-header [data-ajax-cart-trigger]");

      // Removes url to the cart page so user is not redirected
      $el.attr("href", "#");

      $el.off("touchstart").on("touchstart", function (e) {
        // If user clicks inside the element, do nothing
        if (e.target.closest("[data-ajax-cart-mini_cart]")) {
          return;
        }

        // Loads content into ajaxCart container for mobile header
        window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

        // If user clicks outside the element, toggle the mini cart
        $el.toggleClass("show-mini-cart");
      });
    },

    showDrawer: function () {
      if (this.cart_action != "drawer") return false;
      this.ajaxCartDrawer.addClass("is-visible");
      $(".ajax-cart__overlay").addClass("is-visible");
    },

    hideDrawer: function () {
      if (this.cart_action != "drawer") return false;
      this.ajaxCartDrawer.removeClass("is-visible");
      $(".ajax-cart__overlay").removeClass("is-visible");
    },

    removeFromCart: function (lineID, callback) {
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + lineID,
        dataType: "json",
        success: function (cart) {
          window.PXUTheme.jsAjaxCart.updateView();

          // Update cart page if jsCart exists, using promise-based approach
          if (window.PXUTheme.jsCart) {
            window.PXUTheme.jsCart.removeFromCart(lineID);
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          response = response.description;
          console.error("Error removing item from cart:", response);
        },
      });
    },

    // Cache for cart data to avoid redundant requests
    cartCache: null,
    cartCacheTime: 0,
    cartCacheExpiry: 2000, // 2 seconds

    // Load cart data either from cache or from server
    loadCartData: function () {
      const currentTime = Date.now();

      // If we have a recent cache, use it
      if (
        this.cartCache &&
        currentTime - this.cartCacheTime < this.cartCacheExpiry
      ) {
        return Promise.resolve(this.cartCache);
      }

      // Otherwise, fetch fresh data
      return window.PXUTheme.asyncView
        .load(window.PXUTheme.routes.cart_url, "ajax")
        .then((result) => {
          this.cartCache = result;
          this.cartCacheTime = currentTime;
          return result;
        });
    },

    initializeAjaxCart: function () {
      this.loadCartData()
        .then(({ html, options }) => {
          $("[data-ajax-cart-content]").html(html.content);

          // Converting the currencies
          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }
        })
        .catch((error) => {
          console.error("Error initializing cart:", error);
        });
    },

    initializeAjaxCartOnMobile: function () {
      this.toggleMiniCart();

      this.loadCartData()
        .then(({ html, options }) => {
          $(".mobile-header [data-ajax-cart-content]").html(html.content);
        })
        .catch((error) => {
          console.error("Error initializing mobile cart:", error);
        });
    },

    addToCart: function ($addToCartForm) {
      const $addToCartBtn = $addToCartForm.find(".button--add-to-cart");
      this.recipientForm = $addToCartForm[0].querySelector(
        "[data-recipient-form]"
      );

      if (this.recipientForm) {
        this.recipientForm.classList.remove("recipient-form--has-errors");
      }

      $addToCartForm.removeClass("shopify-product-form--unselected-error");

      if ($addToCartBtn[0].hasAttribute("data-options-unselected")) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;
        $(".warning").remove();

        $addToCartForm
          .addClass("shopify-product-form--unselected-error")
          .find(".cart-warning")
          .html(cartWarning);

        $addToCartBtn.removeAttr("disabled").removeClass("disabled");

        $addToCartBtn.find(".icon").removeClass("zoomOut").addClass("zoomIn");

        $addToCartBtn
          .find("span:not(.icon)")
          .text($addToCartBtn.data("label"))
          .removeClass("zoomOut")
          .addClass("zoomIn");
      } else {
        // Start showing loading state immediately
        $addToCartBtn.attr("disabled", "disabled").addClass("disabled");
        $addToCartBtn.find(".nice-frame").text("Adding item...");

        // Clear cart cache to ensure fresh data after add
        this.cartCache = null;

        // Add to cart AJAX request
        $.ajax({
          url: "/cart/add.js",
          dataType: "json",
          cache: true, // Allow browser caching of the request
          type: "post",
          data: $addToCartForm.serialize(),
          success: (product) => {
            let $el = $("[data-ajax-cart-trigger]");

            $addToCartBtn.find(".checkmark").addClass("checkmark-active");

            const addedToCart = () => {
              if (!isScreenSizeLarge()) {
                $el = $(".mobile-header [data-ajax-cart-trigger]");
                window.PXUTheme.scrollToTop($el);
              } else {
                $el = $("[data-ajax-cart-trigger]");
              }

              $el.addClass("show-mini-cart");
              $addToCartBtn.find("span").removeClass("fadeInDown");
            };

            // Update cart view and show drawer
            Promise.all([
              this.updateView(),
              new Promise((resolve) => {
                window.setTimeout(() => {
                  $addToCartBtn.removeAttr("disabled").removeClass("disabled");

                  $addToCartBtn
                    .find(".checkmark")
                    .removeClass("checkmark-active");

                  $addToCartBtn
                    .find(".text, .icon")
                    .removeClass("zoomOut")
                    .addClass("fadeInDown");

                  $addToCartBtn.on(
                    "webkitAnimationEnd oanimationend msAnimationEnd animationend",
                    addedToCart
                  );

                  resolve();
                }, 1000);
              }),
            ]).then(() => {
              this.showDrawer();

              // Update cart page if necessary (using async AJAX)
              if (window.PXUTheme.jsCart) {
                $.ajax({
                  dataType: "html",
                  cache: true,
                  url: "/cart",
                  success: function (html) {
                    const cartForm = $(html).find(".cart__form");
                    $(".cart__form").replaceWith(cartForm);
                  },
                });
              }

              $addToCartBtn.find(".nice-frame").text("Add to cart");
            });
          },
          error: (XMLHttpRequest) => {
            const response = eval("(" + XMLHttpRequest.responseText + ")");
            $(".warning").remove();

            let cartWarning;
            if (response.errors && response.errors.email) {
              this.recipientForm.classList.add("recipient-form--has-errors");
            } else {
              cartWarning = `<p class="cart-warning__message animated bounceIn">${response.description.replace("All 1 ", "All ")}</p>`;
              $addToCartForm.find(".cart-warning").html(cartWarning);
            }

            $addToCartBtn.removeAttr("disabled").removeClass("disabled");

            $addToCartBtn
              .find(".icon")
              .removeClass("zoomOut")
              .addClass("zoomIn");

            $addToCartBtn
              .find("span:not(.icon)")
              .text($addToCartBtn.data("label"))
              .removeClass("zoomOut")
              .addClass("zoomIn");

            $addToCartBtn.find(".nice-frame").text("Add to cart");
          },
        });
      }
    },

    updateView: function () {
      return this.loadCartData()
        .then(({ html, options }) => {
          if (options.item_count > 0) {
            // Batch DOM updates for better performance
            const $content = $(html.content);
            const itemList = $content.find(".ajax-cart__list");
            const cartDetails = $content.find(".ajax-cart__details-wrapper");

            // Use document fragments for better performance
            const fragment = document.createDocumentFragment();
            fragment.appendChild(itemList[0]);

            $(".ajax-cart__list").replaceWith(itemList);
            $(".ajax-cart__details-wrapper").replaceWith(cartDetails);
            $(".ajax-cart__empty-cart-message").addClass("is-hidden");
            $(".ajax-cart__form").removeClass("is-hidden");
            $("[data-ajax-cart-trigger]").addClass("has-cart-count");
            $('[data-bind="itemCount"]').text(options.item_count);
          } else {
            $(".ajax-cart__empty-cart-message").removeClass("is-hidden");
            $(".ajax-cart__form").addClass("is-hidden");
            $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
            $('[data-bind="itemCount"]').text("0");
          }

          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }

          return { html, options };
        })
        .catch((error) => {
          console.error("Error updating cart view:", error);
        });
    },

    unload: function ($section) {
      // Clear event listeners in theme editor
      $(".ajax-submit").off();
      $("[data-ajax-cart-delete]").off();
    },
  };

  /******/
})();
